import axios from "axios"
import { URL_BASE } from '../../../config/config'
''
const RESOURCE = 'rentals/rental_monthly_fees'


export default {

    actions: {
        storeRentalMonthlyFee(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve) => {
                axios.post(`${URL_BASE}${RESOURCE}`, params)
                    .then(response => resolve(response.data))
                    .catch(error => console.log(error))
                    .finally(() => context.commit('PRELOADER', false))
            })                
        },

        updateRentalMonthlyFee(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.put(`${URL_BASE}${RESOURCE}/${params.id}`, params)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        destroyRentalMonthlyFee(context, id){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
                    //.finally(() => context.commit('PRELOADER', false))    
            })
            
        },

        loadPromisseRentalMonthlyFees(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadRentalMonthlyFee(context, id) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadRentalMonthlyFeePdf_(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fee_pdf`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadRentalMonthlyFeePdf(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}rentals/rental_monthly_fee_pdf`,{
                    responseType: "blob",
                    params: params 
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', params.file_name);
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => context.commit('PRELOADER', false))
        },

        loadRentalMonthlyFeeReportPdf(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}rentals/rental_monthly_fee_report_pdf`,{
                    responseType: "blob",
                    params: params 
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', params.file_name);
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => context.commit('PRELOADER', false))
        },

        rentalRentalMonthlyFeeExport(context, params) {         
            return new Promise((reject) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fee_export`, {
                    responseType: "blob",
                    params: params 
                  })
                    .then(response => {
                        const url = URL.createObjectURL(
                            new Blob([response.data], {
                                type: "application/vnd.ms-excel"
                            })
                        );
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "mensalidades_locacao.xls");
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))    
            }) 
        },
        
        rentalRentalMonthlyFeeAlertReportExport(context, params) {         
            return new Promise((reject) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fee_alert_report_export`, {
                    responseType: "blob",
                    params: params 
                  })
                    .then(response => {
                        const url = URL.createObjectURL(
                            new Blob([response.data], {
                                type: "application/vnd.ms-excel"
                            })
                        );
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "mensalidades_locacao_alerts.xls");
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))    
            }) 
        },

        massDestroyMonthlyFee(context, params) {         
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fee_massdestroy`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        rentalMonthlyFeeAlerts(context){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fee_alerts`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },


        rentalMonthlyFeeAlertReport(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fee_alert_reports`, { params })
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        
        massUpdateDueDate(context, params) {         
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.post(`${URL_BASE}rentals/rental_monthly_fee_massupdateduedate`, params)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        massUpdatePaymentTransfer(context, params) {         
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.post(`${URL_BASE}rentals/rental_monthly_fee_massupdatepaymenttransfer`, params)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        rentalMonthlyFeesPaymentDueAlert(context, params) {         
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fees_payment_due_alert`, { params })
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        rentalMonthlyFeesPaymentDueAlertPdf(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}rentals/rental_monthly_fees_payment_due_alert`,{
                    responseType: "blob",
                    params: params 
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', params.file_name);
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => context.commit('PRELOADER', false))
        },

        

    },

    getters: {

    }

}